import React from "react";
import { withRouter } from "us.common/wIthRouter";
import { ReportingPageHome } from "components/ReportingPage";

const Cnt_Reports_Page: React.FC<any> = (props) => {
  return <ReportingPageHome/>
};

export default withRouter(Cnt_Reports_Page);